<div class="fade modal modal-static pg-show-modal" id="modal-send-cv-one-headquarters" tabindex="-1" role="dialog"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{modalTitle}}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">

                <div id="form-carousel-send-cv" class="carousel slide" data-interval="false" data-keyboard="false">
                    <div class="carousel-inner transition-carousel-inner">

                        <div class="carousel-item active">

                            <ng-container *ngIf="isValidProfile === undefined">
                                <div class="loading-ctn">
                                    <app-loading-table></app-loading-table>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="isValidProfile !== undefined && balance >= 0">

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <p *ngIf="isBulkMode===false" class="font-size-15"><strong>A continuación
                                                <span class="text-primary">enviarás tu currículum</span> a
                                                {{institutionName}}</strong> para que la institución te conozca, y
                                            te
                                            puedan invitar a futuros procesos de reclutamiento. </p>

                                        <div *ngIf="isBulkMode===true" class="font-size-15">
                                            <p data-pg-collapsed><strong>A continuación <span
                                                        class="text-primary">enviarás tu currículum</span> a las
                                                    siguientes</strong> instituciones para que te conozcan y te
                                                puedan
                                                invitar a futuros procesos de reclutamiento:</p>
                                            <ol>
                                                <li *ngFor="let e of employerListName">{{e}}</li>
                                            </ol>
                                        </div>
                                        <p *ngIf="isMultiAddress===true" class="font-size-15">La institución realiza
                                            reclutamientos en múltiples
                                            comunas, por lo cual a continuación <strong>deberás seleccionar en
                                                cuales
                                                comunas te interesa trabajar</strong>:</p>



                                        <div *ngIf="isMultiAddress===true" class="form-group"
                                            [formGroup]="_formGroupModal" id="fg-input-city">
                                            <label for="recruit-city-send-cv">Comunas</label>

                                            <ng-select2 [data]="dataSelectAddress"
                                                [options]="constantsService.optionsSelect2MultipleWithoutTag"
                                                [dropdownParent]="'fg-input-city'"
                                                formControlName="institutionAddress">
                                            </ng-select2>

                                            <small class="form-text text-muted">Puedes escribir para buscar
                                                rápidamente.</small>
                                        </div>
                                        <p class="font-size-13">Te avisaremos cuando se publiquen anuncios de esta
                                            institución.</p>

                                        <div class="alert alert-warning d-flex font-size-13 text-dark"
                                            *ngIf="isValidProfile === false">
                                            <div class="mgn-rigth-12">
                                                <i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                            </div>
                                            <div>
                                                <ol class="padding-left-15">
                                                    <li>
                                                        Tu perfil no está lo suficientemente completo para acceder a
                                                        esta función.
                                                        Has clic en el botón "
                                                        <strong>Editar perfil</strong>" para completarlo.
                                                    </li>
                                                    <li>
                                                        Podrás realizar un máximo de {{creditDaily}} envíos de CV
                                                        cada 24 horas.
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                        <div class="alert alert-warning d-flex font-size-13 text-dark"
                                            *ngIf="isValidProfile === true">
                                            <div class="mgn-rigth-12">
                                                <i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                            </div>
                                            <div>Podrás realizar un máximo de {{creditDaily}} envíos de CV cada 24
                                                horas.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 text-center">
                                        <img src="images/enviar-cv.svg" class="img-fluid mgn-bottom-25"
                                            alt="ícono 2 personas junto a un teléfono." />
                                    </div>
                                </div>
                                <div class="form-row mgn-top-40">
                                    <div class="col-12 text-center space-items-15">
                                        <button class="btn btn-outline-primary" data-dismiss="modal"
                                            type="button">Cancelar</button>
                                        <button *ngIf="isValidProfile===true" class="btn btn-primary" type="submit"
                                            [attr.disabled]="_formGroupModal.valid===true? null : true"
                                            (click)="sendResume($event)">Enviar CV</button>
                                        <a [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_EDIT]"
                                            class="btn btn-primary" data-dismiss="modal" role="button">Editar
                                            perfil</a>
                                    </div>
                                </div>

                            </ng-container>

                            <ng-container *ngIf="isValidProfile !== undefined && balance < 0">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center">
                                        <div class="mgn-bottom-15">
                                            <i class="font-size-104 pj-ico pj-ico-cara-triste text-primary"></i>
                                        </div>
                                        <h3 class="font-size-16 font-weight-bold">Lo sentimos…</h3>
                                        <p class="mgn-bottom-25 text-dark">Sólo puedes enviar
                                            <strong>{{creditDaily}} CV
                                                cada 24 horas</strong>.
                                        </p>
                                        <div
                                            class="alert alert-warning d-flex font-size-13 max-width-590 ml-auto mr-auto text-dark">
                                            <div>
                                                <div>
                                                    <h4 class="font-size-16 font-weight-bold">¿Por qué lo hacemos?
                                                    </h4>
                                                </div>
                                                <div class="d-flex">
                                                    <div
                                                        class="align-items-center d-flex padding-left-15 padding-right-15">
                                                        <i class="pj-ico pj-ico-270 pj-ico-ampolleta text-primary"></i>
                                                    </div>
                                                    <div class="padding-left-15 padding-right-15">
                                                        <p class="no-mgn text-left">Porque queremos que postules a
                                                            aquellas instituciones que más te motivan, y así los
                                                            equipos
                                                            de reclutamiento se enfoquen
                                                            en las personas más interesadas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <button class="btn btn-primary" data-dismiss="modal"
                                            type="button">Entiendo</button>
                                    </div>
                                </div>
                            </ng-container>

                        </div>

                        <div class="carousel-item successSlide">
                            <div class="mgn-bottom-25 row">
                                <div class="col-12 text-center">
                                    <i class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-ok"></i>
                                    <p class="mgn-bottom-25 text-dark">Listo, tu currículum fue enviado.</p>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 text-center">
                                    <a class="btn btn-primary " href="#" data-dismiss="modal">Cerrar</a>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item errorSlide">
                            <div class="mgn-bottom-25 row">
                                <div class="col-12 text-center">
                                    <i class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-error"></i>
                                    <h4 class="error-alert-heading text-primary">Lo sentimos, ha ocurrido un error
                                    </h4>
                                    <p class="mgn-bottom-25 text-dark">Presione el botón “Volver a intentar” para
                                        intentarlo otra vez de lo contrario presione “Cerrar” para salir de esta
                                        ventana.</p>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 text-center space-items-15">
                                    <button class="btn btn-outline-primary" data-dismiss="modal"
                                        type="button">Cancelar</button>
                                    <button class="btn btn-primary " (click)="resetStepCarousel()" >Volver a
                                        intentar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>